export default __webpack_public_path__ + "static/media/workshops.aef56a3d.jpg";